var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconListDashes = function SvgIconListDashes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5a1 1 0 0 0 0 2h1.5a1 1 0 0 0 0-2zM9 5a1 1 0 0 0 0 2h11.25a1 1 0 1 0 0-2zM9 11a1 1 0 1 0 0 2h11.25a1 1 0 1 0 0-2zM8 18a1 1 0 0 1 1-1h11.25a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1M2.75 12a1 1 0 0 1 1-1h1.5a1 1 0 1 1 0 2h-1.5a1 1 0 0 1-1-1M3.75 17a1 1 0 1 0 0 2h1.5a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconListDashes;